"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _moment = _interopRequireDefault(require("moment"));

var _ = require("../");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  gap: 0.5rem;\n"])));

var StyledLabel = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 0.5rem;\n  margin-left: 1rem;\n  color: ", ";\n"])), function (p) {
  return p.theme.colorLabel;
});

var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var years = [];
var currentYear = new Date().getFullYear();

for (var y = currentYear - 1; y > 1900; y--) {
  years.push(y);
}

var Wrapper = function Wrapper(_ref) {
  var name = _ref.name,
      value = _ref.value,
      label = _ref.label,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? "MDY" : _ref$format,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur;

  //console.log("value", value);
  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      days = _useState2[0],
      setDays = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = _slicedToArray(_useState3, 2),
      activeMonth = _useState4[0],
      setActiveMonth = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      activeYear = _useState6[0],
      setActiveYear = _useState6[1];

  var _useState7 = (0, _react.useState)(),
      _useState8 = _slicedToArray(_useState7, 2),
      activeDay = _useState8[0],
      setActiveDay = _useState8[1];

  var getDaysInMonth = function getDaysInMonth(month, year) {
    return new Date(year, month, 0).getDate();
  };

  var populateDaysArray = function populateDaysArray(month, year) {
    var daysInMonth = getDaysInMonth(month, year !== null && year !== void 0 ? year : currentYear);
    var daysArray = [];

    for (var i = 0; i < daysInMonth; i++) {
      daysArray.push(i + 1);
    }

    setDays(daysArray);

    if (activeDay > daysInMonth) {
      setActiveDay(daysInMonth);
    }

    return daysArray.length;
  };

  var handleOnChange = function handleOnChange(year, month, day) {
    var dateString = "".concat(year, "/").concat(month < 10 ? "0".concat(month) : month, "/").concat(day < 10 ? "0".concat(day) : day); //console.log("dateString", dateString);

    var isValid = year && month && day;

    if (isValid) {
      onChange({
        name: name,
        target: {
          name: name,
          value: (0, _moment.default)(dateString, "YYYY/MM/DD").format("MM/DD/YYYY")
        }
      });
    }
  };

  var handleDayChanged = function handleDayChanged(e) {
    //console.log("handleDayChanged", activeMonth);
    setActiveDay(+e.target.value);
    handleOnChange(activeYear, activeMonth, +e.target.value);
  };

  var handleYearChanged = function handleYearChanged(e) {
    setActiveYear(+e.target.value);
    populateDaysArray(activeMonth, +e.target.value);
    handleOnChange(+e.target.value, activeMonth, activeDay);
  };

  var handleMonthChanged = function handleMonthChanged(e) {
    setActiveMonth(+e.target.value);
    var generatedDays = populateDaysArray(+e.target.value, activeYear);
    handleOnChange(activeYear, +e.target.value, activeDay > generatedDays ? generatedDays : activeDay);
  };

  (0, _react.useEffect)(function () {
    //console.log("value", value);
    if (value) {
      var existingDate = (0, _moment.default)(value, "MM/DD/YYYY"); //console.log("existingDate", existingDate);

      setActiveDay(+existingDate.format("D"));
      setActiveMonth(+existingDate.format("M"));
      setActiveYear(+existingDate.format("YYYY"));
    }
  }, []);
  (0, _react.useEffect)(function () {
    populateDaysArray(1);
  }, []); //console.log("data", activeMonth);

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [label && /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLabel, {
      children: label
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_.FormSelect, {
        onChange: handleMonthChanged,
        value: activeMonth,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "",
          disabled: true,
          selected: true,
          children: "Month"
        }), months.map(function (m, i) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
            value: i + 1,
            children: m
          });
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_.FormSelect, {
        value: activeDay,
        isError: activeMonth && !activeDay,
        onChange: handleDayChanged,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "",
          disabled: true,
          selected: true,
          children: "Day"
        }), days.map(function (d, i) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
            value: d,
            children: d
          });
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_.FormSelect, {
        value: activeYear,
        isError: activeMonth && !activeYear,
        onChange: handleYearChanged,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
          value: "",
          disabled: true,
          selected: true,
          children: "Year"
        }), years.map(function (y, i) {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("option", {
            value: y,
            children: y
          });
        })]
      })]
    })]
  });
};

var _default = Wrapper;
exports.default = _default;